import React from 'react';

// Paleta de reserva: o cadastro do backend manda as cores, mas sem elas o glifo
// ficaria invisível em vez de degradar para o desenho aprovado.
export const CORES_SITUACAO: Record<string, string> = {
    aguarda: '#a2a9b0',
    liberada: '#0d6efd',
    andamento: '#0d6efd',
    concluida: '#2e9e5b',
    reprovada: '#d0342c',
    cancelada: '#a2a9b0',
    travada: '#d0342c',
};

interface SituacaoGlifoProps {
    situacao: string;
    cor: string;
    size?: number;
    title?: string;
}

// Um desenho por situação, compartilhado pelo grid de obras e pelo painel da obra:
// a forma diferencia mesmo quando duas situações usam a mesma cor.
export const SituacaoGlifo: React.FC<SituacaoGlifoProps> = ({ situacao, cor, size = 13, title }) => {
    const svgProps = {
        className: 'grid-glifo',
        width: size,
        height: size,
        viewBox: '0 0 14 14',
        'aria-hidden': true,
    } as const;

    let desenho: React.ReactNode;
    if (situacao === 'concluida') {
        desenho = (
            <>
                <circle cx="7" cy="7" r="6.2" fill={cor} />
                <path d="M4.2 7.2 6.2 9.2 9.9 4.9" fill="none" stroke="#fff" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
            </>
        );
    } else if (situacao === 'andamento') {
        desenho = (
            <>
                <circle cx="7" cy="7" r="5.4" fill="none" stroke={cor} strokeWidth="1.7" />
                <path d="M7 1.6 A5.4 5.4 0 0 1 7 12.4 Z" fill={cor} />
            </>
        );
    } else if (situacao === 'liberada') {
        desenho = (
            <>
                <circle cx="7" cy="7" r="6.2" fill={cor} />
                <path d="M5.5 4.4 10 7 5.5 9.6 Z" fill="#fff" />
            </>
        );
    } else if (situacao === 'aguarda') {
        desenho = <circle cx="7" cy="7" r="5.4" fill="none" stroke={cor} strokeWidth="1.6" strokeDasharray="2.2 2.1" />;
    } else if (situacao === 'reprovada') {
        desenho = (
            <>
                <circle cx="7" cy="7" r="6.2" fill={cor} />
                <rect x="6.2" y="3.2" width="1.6" height="4.6" rx="0.8" fill="#fff" />
                <circle cx="7" cy="10.1" r="0.95" fill="#fff" />
            </>
        );
    } else if (situacao === 'cancelada') {
        desenho = (
            <>
                <circle cx="7" cy="7" r="6.2" fill={cor} />
                <path d="M4.7 4.7 9.3 9.3 M9.3 4.7 4.7 9.3" stroke="#fff" strokeWidth="1.6" strokeLinecap="round" />
            </>
        );
    } else {
        desenho = (
            <>
                <circle cx="7" cy="7" r="6.2" fill={cor} />
                <rect x="4.1" y="6.4" width="5.8" height="4.1" rx="0.9" fill="#fff" />
                <path d="M5.4 6.4V5.2a1.6 1.6 0 0 1 3.2 0v1.2" fill="none" stroke="#fff" strokeWidth="1.15" />
            </>
        );
    }

    const svg = <svg {...svgProps}>{desenho}</svg>;
    if (!title) return svg;
    return (
        <span className="grid-glifo-wrap" title={title} role="img" aria-label={title}>
            {svg}
        </span>
    );
};

export const CadeadoTravada: React.FC<{ size?: number }> = ({ size = 11 }) => (
    <span className="grid-glifo-cadeado" title="Tarefa travada por impedimento" role="img" aria-label="Tarefa travada por impedimento">
        <svg width={size} height={size} viewBox="0 0 14 14" aria-hidden="true">
            <rect x="2.6" y="6" width="8.8" height="6.2" rx="1.2" fill="#d0342c" />
            <path d="M4.6 6V4.5a2.4 2.4 0 0 1 4.8 0V6" fill="none" stroke="#d0342c" strokeWidth="1.5" />
        </svg>
    </span>
);
